import React from 'react'
import PropTypes from 'prop-types'
import { GoogleLogin } from '@react-oauth/google'

import { sendError } from '@/utils/rollbar'
import { useNonce } from '@/utils/nonce'

export default function GoogleLoginButton({ onSuccess, width = null }) {
  const nonce = useNonce()

  return (
    <GoogleLogin
      nonce={nonce}
      onError={errorResponse => sendError(errorResponse, 'Error signing in with Google')}
      onSuccess={onSuccess}
      width={width || 298}
    />
  )
}

GoogleLoginButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  width: PropTypes.number,
}
